module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "FM-Head-fmh-2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#ckey",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Key Players")])])]), _vm._v(" "), _c('p', {
    staticClass: "List-Head-lh"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("The Dealers")])]), _vm._v(" "), _c('p', {
    staticClass: "List-Unnum-ul-1"
  }, [_vm._v("James “Brick” Feeney—cofounder of Pill City")]), _vm._v(" "), _c('p', {
    staticClass: "List-Unnum-ul-1"
  }, [_vm._v("Willie “Wax” Harris—cofounder of Pill City")]), _vm._v(" "), _c('p', {
    staticClass: "List-Unnum-ul-1"
  }, [_vm._v("Lamonta “Lyric” Johnson—BGF set leader")]), _vm._v(" "), _c('p', {
    staticClass: "List-Unnum-ul-1"
  }, [_vm._v("Desmond “Damage” Vickers—BGF field marshal")]), _vm._v(" "), _c('p', {
    staticClass: "List-Unnum-ul-1"
  }, [_vm._v("Dante “Slim” Robinson—BGF enforcer/dealer, Iraq War veteran")]), _vm._v(" "), _c('p', {
    staticClass: "List-Unnum-ul-1"
  }, [_vm._v("Christopher “Train” Lockwood—BGF enforcer/dealer")]), _vm._v(" "), _c('p', {
    staticClass: "List-Unnum-ul-1"
  }, [_vm._v("Jimmy Masters—leader of the Masters Organization, a Baltimore-based drug syndicate")]), _vm._v(" "), _c('p', {
    staticClass: "List-Unnum-ul-1"
  }, [_vm._v("Ezekiel “Zeke” Masters—Jimmy’s younger brother, responsible for the family’s operations in Kansas City, Missouri")]), _vm._v(" "), _c('p', {
    staticClass: "List-Unnum-ul-1"
  }, [_vm._v("Stephan “Stacks” Masters—Jimmy’s son, drug dealer")]), _vm._v(" "), _c('p', {
    staticClass: "List-Unnum-ul-1"
  }, [_vm._v("Andrew “Blackrock” Masters—Jimmy’s son, responsible for the family’s operations in South Florida")]), _vm._v(" "), _c('p', {
    staticClass: "List-Unnum-ul-1"
  }, [_vm._v("Kenny “Mondo” Mack—Jimmy’s nephew and security chief")]), _vm._v(" "), _c('p', {
    staticClass: "List-Unnum-ul-1"
  }, [_vm._v("Lionel “Dome” Simmons—BGF enforcer")]), _vm._v(" "), _c('p', {
    staticClass: "List-Unnum-ul-1"
  }, [_vm._v("Raheem Wallace—computer hacker, high-ranking member of the Youngstown Boys drug syndicate")]), _vm._v(" "), _c('p', {
    staticClass: "List-Head-lh"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("The Customers")])]), _vm._v(" "), _c('p', {
    staticClass: "List-Unnum-ul-1"
  }, [_vm._v("Keisha Jones—opiate addict, mother of a six-year-old boy")]), _vm._v(" "), _c('p', {
    staticClass: "List-Unnum-ul-1"
  }, [_vm._v("Terry Augman—opiate addict, pregnant with her first child")]), _vm._v(" "), _c('p', {
    staticClass: "List-Unnum-ul-1"
  }, [_vm._v("Derek Curry—opiate addict, former professional jazz guitarist")]), _vm._v(" "), _c('p', {
    staticClass: "List-Unnum-ul-1"
  }, [_vm._v("Otis Washington—opiate addict, former sanitation worker")]), _vm._v(" "), _c('p', {
    staticClass: "List-Head-lh"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("The Investigators")])]), _vm._v(" "), _c('p', {
    staticClass: "List-Unnum-ul-1"
  }, [_vm._v("Frank Calvacca—Narcotics detective, Chicago Police Department")]), _vm._v(" "), _c('p', {
    staticClass: "List-Unnum-ul-1"
  }, [_vm._v("Jamal Grayson—Narcotics detective, Baltimore Police Department")]), _vm._v(" "), _c('p', {
    staticClass: "List-Unnum-ul-1"
  }, [_vm._v("Jeffrey Madigan—Gang detective, Newark Police Department")]), _vm._v(" "), _c('p', {
    staticClass: "List-Unnum-ul-1"
  }, [_vm._v("Mike Malinowski—Sergeant, Baltimore Police Department")]), _vm._v(" "), _c('p', {
    staticClass: "List-Unnum-ul-1"
  }, [_vm._v("Kirstin Marques—Special agent, Drug Enforcement Administration")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76cb07e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/key.vue
// module id = 81
// module chunks = 0